//

import { memo, useMemo } from "react";
import Highlighter from "react-highlight-words";
import { DetailType } from "./types";
import { getHostname, shortDateTime } from "./util";

const HOSTNAME_COLORS = [
  "#fde4cf44",
  "#8eecf544",
  "#b9fbc044",
  "#cfbaf044",
  "#a3c4f344",
  "#fbf8cc44",
];

interface PublishDetailsProps {
  details: DetailType[];
  filter: string;
  displayUTC: boolean;
}

const PublishDetailsItem = memo(({
  timeStamp,
  message,
  filter,
  displayUTC,
}: DetailType & { filter: string; displayUTC: boolean }) => {
  const className = `item${message.includes("Exception") ? " exception" : ""}`;
  
  const hostname = getHostname(message);
  const colorIndex = hostname && hostname.length > 0 ? parseInt(hostname[hostname.length - 1]) : -1;
  const backgroundColor = !isNaN(colorIndex) && colorIndex < HOSTNAME_COLORS.length 
    ? HOSTNAME_COLORS[colorIndex] 
    : "";

  const renderedMessage = filter ? (
    <Highlighter
      highlightClassName="YourHighlightClass"
      searchWords={[filter]}
      autoEscape={true}
      textToHighlight={message}
    />
  ) : (
    message
  );

  return (
    <div className={className} style={backgroundColor ? { backgroundColor } : undefined}>
      {shortDateTime(timeStamp, displayUTC)} - {renderedMessage}
    </div>
  );
});

PublishDetailsItem.displayName = "PublishDetailsItem";

const PublishDetails = memo(({
  details,
  filter,
  displayUTC,
}: PublishDetailsProps) => {
  const filteredAndSortedDetails = useMemo(() => details, [details]);

  return (
    <div className="publish-details">
      {filteredAndSortedDetails.map((item, idx) => (
        <PublishDetailsItem
          key={idx}
          {...item}
          filter={filter}
          displayUTC={displayUTC}
        />
      ))}
    </div>
  );
});

PublishDetails.displayName = "PublishDetails";

PublishDetails.displayName = "PublishDetails";

export default PublishDetails;
